import { gen } from '../../views/utils'

const DEFAULT_GROUP_SETTINGS = {
  calHoursRange: [8, 20],
  currency: 'EUR',
  // invoiceId: null,
  invoiceNo: 'IV000001',
  isLastInvoiceNoRecyclable: true,
  isOnlyDone: false, // user can't yet change this
  isVatEnabled: false,
  isVatIncluded: false,
  mileageUnits: 0,
  vatName: 'VAT',
  vatNumber: null,
  vatParts: 23,
  vatWork: 13.5,
}

export default {
  auto: '*',

  store: {
    getters: {
      genGroup: gen(() => ({
        name: null,
        settings: {
          currency: 'EUR',
          mileageUnits: 0,
        },
      })),

      isGroupFull: () => group =>
        ['address', 'addressSec', 'phone', 'email', 'companyName']
          .every(key => group[key]),

      _group: (_, getters) => getters.query('groups', {}, true),
      group: (_, getters) => getters._group,

      groupSettings: (_, { group }) => ({
        ...DEFAULT_GROUP_SETTINGS,
        ...(group ? group.settings : {}),
      }),

      overrideWithGroupSettings: (_, { groupSettings }) => settings => {
        Object
          .keys(settings)
          .forEach((key) => {
            if (typeof groupSettings[key] !== 'undefined') {
              settings[key] = groupSettings[key]
            }
          })

        return settings
      }
    },
    actions: {
      PATCH_GROUPS_SETTINGS({ dispatch }, { group, ...update }) {
        const settings = {
          ...group.settings,
          ...update,
        }

        return dispatch('PATCH_GROUPS', { settings })
      },
    },
  },
}



// WEBPACK FOOTER //
// ./src/store/modules/groups.js